export default __webpack_public_path__ + "static/media/deer_creek_350.b009cfac.webp";